/**
 * Safely extract a human-readable error message from an unknown caught value.
 */
export function getErrorMessage(err, fallback = 'An unexpected error occurred') {
    if (err instanceof Error)
        return err.message;
    if (typeof err === 'string')
        return err;
    return fallback;
}
//# sourceMappingURL=errorUtils.js.map